import * as Yup from "yup"

import {
	AssetMatchesBrandStatus,
	PriorityLevel,
} from "models"
import {
	MatchProposalFilter,
} from "components/match-proposal/model"

export class MatchProposalAdvancedSearchForm
{
	brand: string|null = null
	priority: PriorityLevel|null = null
	status: AssetMatchesBrandStatus|null = null
	compatibility: number|null = null
	operator: string|null = null
	address: string|null = null

	public toRequest(): MatchProposalFilter
	{
		const result = new MatchProposalFilter()

		result.brand = this.brand === "" ? null : this.brand
		result.priority = this.priority
		result.status = this.status
		result.compatibility = this.compatibility
		result.operator = this.operator === "" ? null : this.operator
		result.address = this.address

		result.orderType = null
		result.orderBy = null

		return result
	}
}

export default Yup.object()
	.shape({})
	.required()
